import React, { useState, useCallback } from 'react';
import { Circle } from '@uiw/react-color';
import { ColorResult } from '@uiw/react-color';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

interface ColorCirclePickerProps {
  baseColor?: string;
  onColorChange: (color: string) => void;
}

export function ColorCirclePicker({
  baseColor,
  onColorChange,
}: ColorCirclePickerProps) {
  const language = useLanguage();
  const [hex, setHex] = useState(baseColor ?? '#f7f7f7');

  const handleColorChange = useCallback(
    (color: ColorResult) => {
      setHex(color.hex);
      onColorChange(color.hex);
    },
    [onColorChange],
  );

  return (
    <div
      className="w-64 p-6"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <div className="pb-2">
        <S2Typography
          variant="body-7-bold"
          translatedContent={language.applyAColor()}
          textColorVariant="gray-900"
        />
      </div>
      <Circle
        colors={[
          '#f7f7f7',
          '#7F8488',
          '#3088E0',
          '#537AEE',
          '#7373FA',
          '#A95FF1',
          '#E73A90',
          '#EE3F3F',
          '#DB5326',
          '#AD9306',
          '#379A15',
          '#0B9674',
        ]}
        color={hex}
        pointProps={{
          style: {
            width: 24,
            height: 24,
          },
        }}
        onChange={handleColorChange}
      />
    </div>
  );
}
